import React from "react";
import styled from "styled-components";
import { FaLeaf, FaBullseye, FaCheckCircle } from "react-icons/fa";

const Adbluedetails = () => {
  return (
    <Adblue>
      <div className="about">
        <div className="heading1">What is MShine D.E.F?</div>
        <div className="about-box">
          <p>
            MShine DEF (Diesel Exhaust Fluid) is a high-quality solution that
            reduces harmful emissions in diesel engines while promoting cleaner
            air and improved fuel efficiency, all while being compliant with the
            ISO 22241 standard.
          </p>
        </div>
      </div>

      <div className="benefits-and-purpose">
        <div className="box">
          <div className="icon">
            <FaLeaf />
          </div>
          <div className="heading2">Benefits of MShine AdBlue</div>
          <ul>
            <li>
              <FaCheckCircle /> <strong>Separate NOx pollution:</strong>{" "}
              Converts NOx pollution to nitrogen and water.
            </li>
            <li>
              <FaCheckCircle /> <strong>Environment friendly:</strong> Reduces
              harmful emissions and is safe for the environment.
            </li>
            <li>
              <FaCheckCircle /> <strong>Efficiency:</strong> Lowers the cost of
              vehicle operation by improving fuel efficiency.
            </li>
          </ul>
        </div>

        <div className="box">
          <div className="icon">
            <FaBullseye />
          </div>
          <div className="heading2">Important Instructions</div>
          <ul>
            <li>
              <FaCheckCircle />{" "}
              <strong>Do not fill into diesel/fuel tank.</strong>
            </li>
            <li>
              <FaCheckCircle />{" "}
              <strong>Store below 30°C and above -10°C:</strong> Avoid direct
              exposure to sunlight.
            </li>
            <li>
              <FaCheckCircle /> <strong>Keep away from dust and dirt.</strong>
            </li>
            <li>
              <FaCheckCircle /> <strong>Use immediately after opening:</strong>{" "}
              Consume the container fully after opening to avoid contamination.
            </li>
          </ul>
        </div>
      </div>
    </Adblue>
  );
};

const Adblue = styled.section`
  padding: 40px 20px;
  background: #f7f7f7;
  font-family: "Inter", sans-serif;

  .about {
    margin-bottom: 40px;
  }

  .heading1 {
    text-transform: uppercase;
    font-size: 2.5rem;
    color: white;
    background-color: #2363e7;
    /* color: #00796b; */
    font-family: "Play", "sans-serif";
    font-weight: 700;
    text-align: center;
    margin-bottom: 20px;
    font-style: italic;
    padding: 5px;
  }

  .about-box {
    background-color: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  .about-box p{
    font-size: 1.1rem;
  }

  .benefits-and-purpose {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 50px;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .box {
    background-color: white;

    padding: 30px;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    position: relative;
    text-align: left;

    .icon {
      font-size: 3rem;
      color: #2363e7;
      /* color: 	rgb(255, 191, 0); */
      /* color: #00796b; */
      position: absolute;
      top: -25px;
      left: 20px;
      background-color: white;
      border-radius: 50%;
      padding: 5px;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
      width: 70px;
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .heading2 {
      font-size: 1.5rem;
      font-weight: 600;
      color: #333;
      margin: 20px 0;
      padding-left: 60px; /* Icon spacing */
      text-transform: uppercase;
      font-family: "Inter";
    }

    ul {
      list-style-type: none;
      padding-left: 60px; /* Icon spacing */
      li {
        margin-bottom: 15px;
        font-size: 1.1rem;
        line-height: 1.5;
        color: #424242;
        font-family: "Play";
      }

      svg {
        color: #2363e7;
        /* color: #00796b; */
        margin-right: 10px;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 20px;

    .heading1 {
      font-size: 2rem;
    }

    .about-box {
      padding: 15px;
    }

    .box {
      padding: 20px;
    }

    .heading2 {
      font-size: 1.3rem;
    }
  }
`;

export default Adbluedetails;
